import React, {useState} from 'react';
import { useParams } from "react-router-dom";
import Loader from '../../components/Loader';
import { useUser, isAdmin } from '../../contexts/UserContext';
import { dateFromTimestampToString } from '../../librairies/Dates';
import {useFirestoreCollection} from '../../librairies/Firestore';
import DataTable from '../table/Datatable';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import AddItem from '../actions/AddItem';
import ToggleActivationLink from '../actions/ToggleActivationLink';
import { db } from '../../firebase';
import { addDoc, collection, doc, getDoc, setDoc, Timestamp } from 'firebase/firestore';
import { isManager } from '../../contexts/UserContext';

const Silos = () => {

  const { client_id, site_id } = useParams(); // Capture l'ID du client depuis l'URL
  const { data: silos, loader } = useFirestoreCollection(`clients/${client_id}/sites/${site_id}/silos`);
  const [ajoutSilo, popupAjoutSilo] = useState(false);

  //contexte de l'utilisateur connecté
  const user = useUser();

  const columns = [
    { header: 'Nom', render: (silo) => silo.nom },
    { header: 'Nombre de machines', render: (silo) => silo.nbItems },
    { header: 'Maintenance effectuée', render: (silo) => (silo.nbMaintenance && silo.nbItems) ? (
      <div>
        {Math.round((silo.nbMaintenance / silo.nbItems) * 100)}%
      </div>
    ) : (
      <div>
        0%
      </div>
    )},
    { header: 'Date de création', render: (silo) => dateFromTimestampToString(silo.dateCreation.seconds) },
    { header: 'Active', render: (silo) => (silo.active ? "Activé" : "Désactivé") },
    { header: 'Action', render: (silo) => (
      <div className='flex gap-4'>
        <ToggleActivationLink collection={`clients/${client_id}/sites/${site_id}/silos`} item={silo} /> 
        {(isManager(user.user) && ((silo.nbMaintenance - silo.nbItems) >= 0) && silo.dateRapportMaintenance == undefined ) ? (
          <a
            href="#"
            onClick={(event) => createRapportMaintenanceGlobal(event, silo)}
            className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
          >
            Créer rapport de maintenance
          </a>
        ) : null }
      </div>
    )}
  ];


  const createRapportMaintenanceGlobal = async (event, silo) => {

    event.preventDefault();
    event.stopPropagation();

    try{
      let nomSite = ""; 
      
      const docRef = doc(db, `clients/${client_id}/sites/`, site_id);

      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        // Le document existe, vous pouvez accéder à ses données
        nomSite= docSnap.data().nom;
      }

      //on ajoute le nouveau document avec un nouveau compte pour le syndic
      const createRapportGlobalCollection = collection(db, "create_rapport_global");

      await addDoc(createRapportGlobalCollection, {
        clientId: client_id,
        siteId: site_id,
        siloId: silo.id,
        managerId: user.user.user.uid,
        title: "Rapport maintenance - "+nomSite+" - "+silo.nom
      }).then(async (document) => {

        const siloRef = doc(db, `clients/${client_id}/sites/${site_id}/silos/${silo.id}`);
        setDoc(siloRef, { dateRapportMaintenance: Timestamp.now() }, { merge: true });

        alert("Le rapport sera créé d'ici quelques secondes et sera disponible dans le menu Rapports de maintenance");
      }).catch((err) => {
        alert("Une erreur est survenue, impossible de créer le rapport de maintenance");
        return; 
      });
    }catch(err){
      alert("Une erreur est survenue, impossible de créer le rapport de maintenance");
    }
  }

  return (
    <div>
      {isAdmin(user.user) ? (
        <a href="#" onClick={() => popupAjoutSilo(true)} className="justify-end flex mb-4">
          <PrimaryButton type={"button"} value={"Ajouter un silo"} loading={false} />
        </a>
      ) : null }

      {loader ? (
        <Loader />
      ) : (
        <DataTable 
          data={silos} 
          columns={columns} 
          onRowClick={(silo) => window.location.href = `/client/${client_id}/site/${site_id}/silo/${silo.id}`}
        />
      )}

      {ajoutSilo ? (
        <AddItem
          onClose={() => popupAjoutSilo(false)}
          collectionPath={`clients/${client_id}/sites/${site_id}/silos`}
          title="Ajouter un silo"
          fields={[
            { name: "nom", label: "Nom du silo", type: "text" },
          ]}
        />
      ) : null }
    </div>
  );
};

export default Silos;
